const Marionette = require('backbone.marionette');
const templates = require('../templates');
const PopupFooterActivityChildView = require('./popup_footer_activity.js');

module.exports = Marionette.CompositeView.extend({
  template: templates.popup_footer_actually,
  childView: PopupFooterActivityChildView,
  childViewContainer: '.right_block .courses',
  childViewOptions(model) {
    return {
      model,
      hour: false
    };
  },
  emptyView: Marionette.ItemView.extend({
    template: templates.popup_footer_activities_empty
  })
});



// WEBPACK FOOTER //
// ./src/views/popup_footer_actually.js